export default [
  {
    "title": "MANUAL DEL SISTEMA DE GESTIÓN DE MEDICIONES",
    "code": "MAN-SGMES-EMP-001",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA EL CONTROL DE DOCUMENTOS Y REGISTROS",
    "code": "PRO-SGMES-EMP-001",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA REALIZACIÓN DE AUDITORÍAS",
    "code": "PRO-SGMES-EMP-002",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LAS REVISIONES POR LA DIRECCIÓN",
    "code": "PRO-SGMES-EMP-003",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO DE CAPACITACIÓN DEL PERSONAL",
    "code": "PRO-SGMES-EMP-004",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LOS EQUIPOS DE MEDICIÓN",
    "code": "PRO-SGMES-EMP-005",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA EVALUACIÓN DE PROVEEDORES",
    "code": "PRO-SGMES-EMP-006",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA ACCIONES PREVENTIVAS Y DE MEJORA",
    "code": "PRO-SGMES-EMP-007",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA ACCIONES CORRECTIVAS",
    "code": "PRO-SGMES-EMP-008",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA CONFIRMACIÓN METROLÓGICA",
    "code": "PRO-SGMES-EMP-009",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA ATENCIÓN DE QUEJAS",
    "code": "PRO-SGMES-EMP-010",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA IDENTIFICACIÓN Y EL CONTROL DE RIESGOS",
    "code": "PRO-SGMES-EMP-011",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO DE PREPARACIÓN Y RESPUESTA A EMERGENCIAS",
    "code": "PRO-SGMES-EMP-012",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA ESTIMACIÓN DE LA INCERTIDUMBRE",
    "code": "PRO-SGMES-EMP-013",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO PARA LA MEDICIÓN DE TANQUES DE ALMACENAMIENTO",
    "code": "PRO-SGMES-EMP-014",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE CONFIDENCIALIDAD DE LOS DOCUMENTOS DEL SISTEMA DE GESTIÓN DE MEDICIÓN",
    "code": "FOR-SGMES-EMP-001",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "LISTA MAESTRA DE CONTROL DE DOCUMENTOS Y REGISTROS",
    "code": "FOR-SGMES-EMP-002",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE CONTROL DE DISTRIBUCIÓN DE DOCUMENTOS Y REGISTROS",
    "code": "FOR-SGMES-EMP-003",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROGRAMA DE REVISIÓN DE DOCUMENTOS Y REGISTROS",
    "code": "FOR-SGMES-EMP-004",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE CONTROL DE DIFUSIÓN DE DOCUMENTOS",
    "code": "FOR-SGMES-EMP-005",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE CONTROL DE RETIRO DE DOCUMENTOS OBSOLETOS",
    "code": "FOR-SGMES-EMP-006",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE DESIGNACIÓN DE LA FUNCIÓN METROLÓGICA",
    "code": "FOR-SGMES-EMP-007",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROGRAMA DE REVISIONES POR LA DIRECCIÓN",
    "code": "FOR-SGMES-EMP-008",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "MINUTA DE REVISIONES POR LA DIRECCIÓN",
    "code": "FOR-SGMES-EMP-009",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE DESCRIPCIÓN DE PUESTOS DE TRABAJO",
    "code": "FOR-SGMES-EMP-010",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "LISTA DE ASISTENCIA",
    "code": "FOR-SGMES-EMP-011",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROGRAMA ANUAL DE CAPACITACIÓN",
    "code": "FOR-SGMES-EMP-012",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE REPORTE DE ACCIONES CORRECTIVAS",
    "code": "FOR-SGMES-EMP-013",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FICHA TÉCNICA DE EQUIPOS",
    "code": "FOR-SGMES-EMP-014",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE REPORTE DE ACCIONES PREVENTIVAS",
    "code": "FOR-SGMES-EMP-015",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROGRAMA DE AUDITORIAS",
    "code": "FOR-SGMES-EMP-016",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PLAN DE AUDITORIAS",
    "code": "FOR-SGMES-EMP-017",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE HALLAZGO DE AUDITORÍA",
    "code": "FOR-SGMES-EMP-018",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE REVISIÓN DE ACCIONES CORRECTIVAS Y PREVENTIVAS",
    "code": "FOR-SGMES-EMP-019",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE DETECCIÓN DE NECESIDADES DE CAPACITACIÓN",
    "code": "FOR-SGMES-EMP-020",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE EVALUACIÓN INDIVIDUAL DE CURSOS Y CAPACITACIONES",
    "code": "FOR-SGMES-EMP-021",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "AVISO DE CONFORMACIÓN DEL EQUIPO AUDITOR",
    "code": "FOR-SGMES-EMP-022",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "REQUISICIÓN DE MATERIAL O SERVICIO",
    "code": "FOR-SGMES-EMP-023",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO PARA LA EVALUACIÓN DE PROVEEDORES",
    "code": "FOR-SGMES-EMP-024",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE VERIFICACIÓN DE PRODUCTOS O SERVICIOS",
    "code": "FOR-SGMES-EMP-025",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "REGISTRO DE QUEJAS",
    "code": "FOR-SGMES-EMP-026",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "MATRIZ DE EVALUACIÓN DE RIESGOS",
    "code": "FOR-SGMES-EMP-027",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "FORMATO DE TOMA DE LECTURAS CON CINTA PETROLERA",
    "code": "FOR-SGMES-EMP-028",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PLANO MECÁNICO",
    "code": "ANEXO 1",
    "version": "NA",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "POLÍTICA DEL SISTEMA DE GESTIÓN DE MEDICIONES",
    "code": "ANEXO 2",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "GUÍA PARA LA ELABORACIÓN DE DOCUMENTOS",
    "code": "ANEXO 3",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PLAN DE ATENCIÓN A EMERGENCIAS",
    "code": "ANEXO 4",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "RESPONSABILIDADES DE LAS BRIGADAS",
    "code": "ANEXO 5",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "DIRECTORIO DE EMERGENCIAS",
    "code": "ANEXO 6",
    "version": "0",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "REPORTE IMPRESO DE LOS REGISTROS DE MEDICIONES DEL NIVEL DE PRODUCTO Y AGUA",
    "code": "ANEXO 7",
    "version": "NA",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROCEDIMIENTO DE AJUSTE DE VOLUMEN DEL INSTRUMENTO DE MEDICIÓN",
    "code": "ANEXO 8",
    "version": "NA",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  },
  {
    "title": "PROGRAMA ANUAL DE MANTENIMIENTO",
    "code": "ANEXO 9",
    "version": "NA",
    "description": "AUDITORÍA INTERNA / ALTA DIRECCIÓN"
  }
]